<template>
  <div class="menu_container">
    <div class="w-full p-5">
      <template v-if="menu == 'DATA'">
        <POPUP_DEVICE_DATA v-if="device?.config" :config="device.config" />
      </template>

      <template v-if="menu == 'CAMERA_OPTION'">
        <Camera_Option v-if="device?.config" :config="device.config" />
      </template>

      <template v-if="menu == 'FLIGHT'">
        <Popup_Mission
          v-if="device?.config"
          :config="device.config"
          @close="$root.global.menuPopupOpen = false"
        />
      </template>

      <template v-if="menu == 'DOCK_DEBUG'">
        <DockDebug
          v-if="device?.config"
          :config="device.config"
          :smallSvg="false"
        />
      </template>

      <template v-if="menu == 'DRONE_DEBUG'">
        <DroneDebug :config="device.config" :smallSvg="false" />
      </template>
    </div>

    <div class="flex flex-col bg-g1 w-[45px] h-full">
      <div class="menu_item" @click="$root.global.menuPopupOpen = false">
        <SVG name="plus" css="fill-current w-full rotate-45"></SVG>
      </div>
      <div class="my-auto">
        <!-- DATA -->
        <div
          @click="menu = 'DATA'"
          class="menu_item"
          :class="{ active: menu == 'DATA' }"
        >
          <SVG name="drone" css="w-full fill-current"></SVG>
        </div>
        <!-- CAMERA OPTION -->
        <div
          @click="
            menu = 'CAMERA_OPTION';
            $emit('forceAffichage', 'payload');
          "
          class="menu_item"
          :class="{ active: menu == 'CAMERA_OPTION' }"
        >
          <SVG name="camera" css="w-full fill-current"></SVG>
        </div>
        <!-- FLIGHT -->
        <div
          @click="
            menu = 'FLIGHT';
            $emit('forceAffichage', 'map');
          "
          class="menu_item"
          :class="{ active: menu == 'FLIGHT' }"
        >
          <SVG name="flight" css="w-full fill-current"></SVG>
        </div>

        <!-- DOCK DEBUG -->
        <div
          @click="menu = 'DOCK_DEBUG'"
          class="menu_item"
          :class="{ active: menu == 'DOCK_DEBUG' }"
          v-if="
            device?.config?.dock?.id &&
            $root.user.can([3, 4, 5], 'DEVICES.DEBUG.DOCK.debug_mode_active')
          "
        >
          <SVG name="dock_debug" css="w-full fill-current"></SVG>
        </div>
        <!-- DRONE DEBUG -->
        <div
          @click="menu = 'DRONE_DEBUG'"
          class="menu_item"
          :class="{ active: menu == 'DRONE_DEBUG' }"
          v-if="
            device?.config?.drone?.id &&
            $root.user.can([3, 4, 5], 'DEVICES.DEBUG.DRONE.access_edit_drone')
          "
        >
          <SVG name="drone_debug" css="w-full fill-current"></SVG>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import SVG from "@/partials/SVG.vue";

import Camera_Option from "@/app/popup/partial/Camera/Camera_Option.vue";
import DockDebug from "@/partials/Device/Template/Dock/DockDebug.vue";
import DroneDebug from "@/partials/Device/Template/Drone/DroneDebug.vue";
import POPUP_DEVICE_DATA from "@/app/popup/partial/MENU/POPUP_DEVICE_DATA.vue";
import Popup_Mission from "@/app/popup/partial/Popup_Mission.vue";

export default {
  name: "POPUP_MENU",
  components: {
    SVG,
    Camera_Option,
    DockDebug,
    DroneDebug,
    POPUP_DEVICE_DATA,
    Popup_Mission,
  },
  setup() {
    return {
      menu: ref("DATA"),
    };
  },
  props: {
    device: Object,
  },

  mounted() {},

  methods: {},
};
</script>
